import { render } from "./wTimeTableTd.vue?vue&type=template&id=2bb69c92&ts=true"
import script from "./wTimeTableTd.vue?vue&type=script&lang=ts"
export * from "./wTimeTableTd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__